import { useCallback, useEffect, useState } from 'react';
import api from '../config/api';

/**
 * The signed-in partner's plan, limits and introduction fee rate.
 *
 * Several screens quote the fee back to the partner. They used to hard-code 10%,
 * which was right for exactly one of the four tiers, so anything that shows a
 * rate should read it from here instead.
 */
const usePartnerEntitlements = () => {
  const [entitlements, setEntitlements] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('/partners/plan');
      setEntitlements(response.data?.entitlements || null);
      setError(null);
    } catch (fetchError) {
      setEntitlements(null);
      setError(fetchError);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      await load();
      if (!active) return;
    })();
    return () => { active = false; };
  }, [load]);

  return {
    entitlements,
    loading,
    error,
    reload: load,
    // Null rather than a guessed number: a screen should show nothing before it
    // knows the rate, not the wrong rate.
    introductionFeeRate: entitlements?.introductionFeeRate ?? null
  };
};

export default usePartnerEntitlements;
